var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenInNewTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6886",
    "data-name": "Path 6886",
    d: "M18,19H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5h5a1,1,0,0,0,0-2H5A2,2,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V13a1,1,0,0,0-2,0v5A1,1,0,0,1,18,19ZM14,4a1,1,0,0,0,1,1h2.59L8.46,14.13a1,1,0,0,0,1.41,1.41L19,6.41V9a1,1,0,0,0,2,0V4a1,1,0,0,0-1-1H15A1,1,0,0,0,14,4Z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNewTabIcon);
export default __webpack_public_path__ + "static/media/OpenInNewTabIcon.5da40afd113a330160573b6a2b39df15.svg";
export { ForwardRef as ReactComponent };